// JSX port of the companion's js/sections/invite.js — the "Share the care" row WF77 creates
// after the visit. INERT by design: no link, no handler, no storage. A coordinator click must
// never open the write-capable share page, or cancel the patient's task, under their own session.

import React from 'react';
import { pickShareInvite, safeImageUrl } from '@/logic/patientHome';
import { readTaskContext } from '@/logic/task';
import useNow from '@/hooks/useNow';

export default function ShareInviteCard({ tasks, carePeriod }) {
  const now = useNow();
  const invite = pickShareInvite(tasks, carePeriod?.status, now);
  if (!invite) return null;
  const raw = readTaskContext(invite.context_json)?.preview_image_url;
  const img = safeImageUrl(typeof raw === 'string' ? raw : '');

  return (
    <section className="acc-section fade-up" aria-label="Share the care">
      <div className="acc-invite">
        <div className="acc-invite__cta">
          <span className="acc-invite__photo" style={img ? { backgroundImage: `url('${img}')` } : undefined} aria-hidden="true" />
          <span className="acc-invite__body">
            <span className="acc-invite__title">Share the care</span>
            <span className="acc-invite__subtitle">Invite someone: they get their own blood pressure cuff at no cost.</span>
          </span>
        </div>
        <span className="acc-invite__dismiss" aria-hidden="true">×</span>
      </div>
    </section>
  );
}
